import Component from ".";
import authRoles from "../../utils/auth.roles";
const MFARoutes = {
  auth: authRoles.user,
  kyc: false,
  mfaNotRequired: true,
  routes: [
    {
      path: "/mfa",
      component: Component,
      exact: true,
    },
    {
      path: "/mfa/:active",
      component: Component,
      exact: true,
    },
  ],
};
export default MFARoutes;
